export default "__VITE_ASSET__gSrFxhT1__"